module.exports = __webpack_public_path__ + "static/media/arrow-down.607a4deb.svg";